<a
  class="{{ btnClass }}"
  target="_blank"
  href="{{ downloadUrl }}"
  *ngIf="deliveryPackage.state !== DeliveryPackageStates.NEW.toString()"
>
  <i class="fa fa-download"></i> {{ 'Download all' | translate }}
</a>
